function InvoiceDetail() {
  return <div>InvoiceDetail</div>;
}

export default InvoiceDetail;
